import React, { Component } from "react";
import Button from "../../../../../modules/commons/Button";
import { defaultTableChange } from "../../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import PeriodeFilter from "../../common/periodeFilter";
import { getColumns } from "./config";
import TabBBKDetail from "./tabBBKDetail";
import { formGroup } from "../tabBBM/config";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import PaymentReportFilterModal from "../../common/paymentReportFilterModal";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus, Status } from "../../../../common/Constants";
import { mapToDDL } from "../../../../common/mapper";
import _ from 'lodash'
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { printPDF } from "../../common/downloadUtils";

class TabBBKRealisasi extends Component {
    tableColumns = [
        ...getColumns("REALISASI"),
        {
            name: "paymentId",
            label: "Aksi",
            options: {
                customBodyRender: (val) => (
                    <FlexView hAlignContent="center" style={{ gap: 10 }}>
                        <Button className="btnAct" onClick={() => this.handleDetailVisibility(val, false)}>
                            <i
                                className="fa fa-lg fa-eye"
                                style={{
                                    fontSize: 20,
                                    color: 'red'
                                }}
                            />
                        </Button>
                        {this.props.userAccess.updateAccess &&
                            <Button className="btnAct" onClick={() => this.handleDetailVisibility(val, false, "editDDL")}>
                                <i
                                    className="fa fa-lg fa-pencil-alt"
                                    style={{
                                        fontSize: 20,
                                        color: 'red'
                                    }}
                                />
                            </Button>
                        }
                    </FlexView>
                ),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            filterVisible: false,
            modifyingVisible: false,
            detailId: "",
            printReport: {
                visible: false,
                startDate: null,
                endDate: null,
                ddl: null
            },
            bankData: [],
            file: null,
            loading: false,
            isEditable: false,
        };
    }

    componentDidMount() { 
        this.fetchDataBank()
    }

    componentDidUpdate(prevProps, prevState) { 
        if(prevProps.kodeCabang?.value !== this.props.kodeCabang?.value){
            this.fetchDataBank()
        }
    } 

    fetchDataBank = async () => {
        try {
            this.handleTriggerLoading()
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank({
                paramFilters: {
                    kodeCabang: [this.props.kodeCabang?.value],
                },                
            })
            if(response.ok && response.data.status === HttpStatus.SUCCESS){
                 const data = response.data.data.map(({bankName,bankCode})=> mapToDDL(`${bankCode} - ${bankName}`, bankCode))
                this.setState({
                    bankData: _.sortBy(data,'label')
                })
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.handleTriggerLoading()
        }
    }

    handleTriggerLoading = () => {
        this.setState(prev => ({
            ...prev,
            loading: !prev.loading
        }))
    }

    handleDetailVisibility = (id = "", editable = false, action = "") => {
        if (R.isNil(id)) {
            this.props.onRefresh();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            detailId: id,
            isEditable: editable,
            action: action,
            modifyingVisible: !prevValue.modifyingVisible
        }));
    };

    handlePaymentReportModalVisibility = () => {
        this.setState((prev) => ({
            ...prev,
            printReport: {
                ...prev.printReport,
                visible: !prev.printReport.visible
            },
        }));
    };

    handleChangePaymentReportModal = (name, value) => {
        this.setState((prev) => ({
            ...prev,
            printReport: {
                ...prev.printReport,
                [name]: value
            },
        }));
    };

    handlePrint = async () => {
        try {
            this.handleTriggerLoading()
            const { visible, ...rest } = this.state.printReport;
        
            const payload = {
              startDate: rest.startDate,
              endDate: rest.endDate,
              kodeCabang: this.props.kodeCabang?.value,
              bankCode: rest.ddl?.value || null,
            }

            const response = await fetchDataAsync({
              asyncFn: Api.create("NAGAMAS_REPORT").printBBKRealizationReport,
              setError: this.props.setError,
              menuName: "Transaksi Bank - BBM",
              args: payload,
            });
            this.handleTriggerLoading()

            if(response.ok){
                printPDF(response.data)
                this.handlePaymentReportModalVisibility();
            }
        } catch (error) {
            console.log(error)   
        }
    }

    render() {
        return (
            <div>
                <PeriodeFilter
                    {...this.props}
                    title="Tanggal Realisasi"
                    withFilterButton
                    startDateName="tanggalAwal"
                    endDateName="tanggalAkhir"
                    onValueChange={this.props.onPeriodChange}
                    onSubmit={this.props.onSubmitPeriod}
                    onShowFilter={this.props.onShowFilter}
                />
                <SimpleDataTable
                    data={this.props.state.dataTable}
                    columns={this.tableColumns}
                    rowsPerPage={this.props.state.pagination.limit}
                    page={this.props.state.pagination.page - 1}
                    toCount={this.props.state.pagination.totalData}
                    options={defaultTableChange(this.props.onChangePage, this.props.onChangeRowsPerPage)}
                />
                <FlexView vAlignContent={"center"} hAlignContent={"right"} style={{marginTop: "20px"}}>
                    <SimpleButton
                        text="Cetak"
                        onClick={() => this.handlePaymentReportModalVisibility()}
                    />
                </FlexView>
                {this.state.modifyingVisible && (
                    <TabBBKDetail
                        formGroup={formGroup}
                        title="Detail BBK REALISASI"
                        paymentStatus={"REALISASI"}
                        id={this.state.detailId}
                        visible={this.state.modifyingVisible}
                        namaCabang={this.props.kodeCabang}
                        kodeCabang={this.props.kodeCabang?.value}
                        action={this.state.action}
                        isEditable={this.state.isEditable}
                        onClickClose={this.handleDetailVisibility}
                    />
                )}
                {this.state.printReport.visible && (
                  <PaymentReportFilterModal
                    visible={this.state.printReport.visible}
                    onClickClose={this.handlePaymentReportModalVisibility}
                    startDateName="startDate"
                    endDateName="endDate"
                    startDate={this.state.printReport.startDate}
                    endDate={this.state.printReport.endDate}
                    ddl={this.state.printReport.ddl}
                    onValueChange={this.handleChangePaymentReportModal}
                    ddlData={this.state.bankData}
                    onPrint={this.handlePrint}
                    type="bank"
                  />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
            </div>
        );
    }
}

export default TabBBKRealisasi;
